// eslint-disable-next-line import/prefer-default-export
export const mapCollectionToSelectOptions =
  (textField = 'name', valueField = 'id', langField = 'lang') =>
  (item: any) => ({
    text: item[textField],
    value: item[valueField],
    lang: item[langField],
  });
